import { useEffect, useState } from 'react'
import { ethers } from 'ethers'

export const useNetwork = () => {
  const [chainId, setChainId] = useState(null)

  useEffect(() => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum)
      provider.getNetwork().then((network) => {
        setChainId(network.chainId)
      })

      window.ethereum.on('chainChanged', (chain) => {
        setChainId(Number(chain))
      })
    }
  }, [])

  return { chainId }
}
